<template lang="pug">
  div.apply-bulk.px-4.pt-2
    div.label.basic600--text.text-uppercase {{$t('apply_to_all')}}
      v-form(ref="form")
        v-row(no-gutters)
          v-col.mr-2
            p.mb-2.label.basic600--text {{$t('tier')}}
            v-select(v-model="tier" :disabled="isFetching" outlined dense :items="companyTiers" item-text="name" item-value="id" hide-selected hide-details)
          v-col
            p.mb-2.label.basic600--text {{$t('value')}}
            v-text-field(v-model.number="value" :disabled="isFetching || !tier" :placeholder="!tier ? $t('select_tier') : ''" hide-details="auto" dense outlined height="40" background-color="basic200" type="number" :suffix="suffix" :prefix="prefix" :rules="rules.number_not_empty")
        v-btn.mt-3(outlined dense block style="background-color: var(--v-infoT08); border: solid 1px var(--v-info500)" :disabled="isFetching" @click="clickApply")
          .button-AA-medium.info500--text {{$t('apply')}}
    div.d-flex.align-center.pt-2
      eva-icon.mb-n1.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="24" height="24")
      div.c1.basic600--text {{$t('apply_to_all_desc')}}
</template>

<script>
export default {
  name: 'ProductTiersApplyAll',
  props: {
    isFetching: {
      type: Boolean
    },
    companyTiers: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      value: null,
      tier: null,
      rules: {
        number_not_empty: [v => v !== null || 'This field is required', v => v !== '' || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v > 0 || 'Price should be more than 0'],
        weight: [v => v !== null || 'This field is required', v => v !== '' || 'This field is required', v => v >= 0 || 'Weight should be positive', v => v <= 60 || 'Weight should not be above 60 KG']
      }
    }
  },
  computed: {
    prefix() {
      const found = this.companyTiers.find(tier => tier.id === this.tier)
      if (found && found.commission_type === 'amount') {
        return this.$currency.symbol
      }
      return null
    },
    suffix() {
      const found = this.companyTiers.find(tier => tier.id === this.tier)
      if (found && found.commission_type === 'percentage') {
        return '%'
      }
      return null
    }
  },
  methods: {
    clickApply() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.$emit('updateData', { tier: this.tier, value: this.value })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.value-changed {
  border: 1px solid var(--v-success500);
}
</style>

<i18n>
{
  "en": {

    "apply_to_all":"Apply commissions to all",
    "apply_to_all_desc":"This commission for selected tier will be applied to all products in this page",
    "tier":"Tier",
    "value":"Value",
    "select_tier":"Select Tier"
    },
  "id": {
    "apply_to_all":"Terapkan komisi",
    "apply_to_all_desc":"Komisi untuk tingkat yang dipilih ini akan diterapkan ke semua produk di halaman ini",
    "tier":"Tingkat",
    "value":"Jumlah Komisi",
    "select_tier":"Pilih Tingkat Komisi"
    }

}


</i18n>